import type { Hypothesis } from '../../types/organizer';

/**
 * Selects a numeric value from the hypothesis list by name.
 */
export const getSignalValue = (
    hypotheses: Hypothesis[],
    hypothesisName: Hypothesis['name'],
): number | undefined => {
    const matchingHypothesis = hypotheses.find(
        (hypothesis) => hypothesis.name === hypothesisName,
    );

    if (!matchingHypothesis) {
        return undefined;
    }

    switch (matchingHypothesis.name) {
        case 'eventsHosted':
            return matchingHypothesis.value.eventsHosted;
        case 'tenureInMonths':
            return matchingHypothesis.value.tenureInMonths;
        case 'attendeesHosted':
            return matchingHypothesis.value.attendeesHosted;
        case 'repeatAttendees':
            return matchingHypothesis.value.repeatAttendees;
        default:
            return undefined;
    }
};
